import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "start-guide" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "kicker" }, " Welcome to Augmentify ", -1)
const _hoisted_3 = { class: "heading h1 title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "body-text body" }, " It’s very easy, just follow these three steps ", -1)
const _hoisted_5 = { class: "grid-x flex-xy-center" }
const _hoisted_6 = { class: "cell small-4 medium-4 xxlarge-3" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "cell small-8 medium-12 xxlarge-8 xxlarge-offset-1" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "grid-x flex-xy-center" }
const _hoisted_11 = { class: "cell small-4 medium-4 xxlarge-3" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "cell small-8 medium-12 xxlarge-8 xxlarge-offset-1" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { NCard, NTag, NGrid, NGi } from 'naive-ui'
import {submitRequirementsIcon, reviewCandidatesIcon, bookMeetingIcon, getAugmentedIcon } from '@/assets/utils/icons'


export default /*#__PURE__*/_defineComponent({
  __name: 'StartGuide',
  setup(__props) {

const steps = [
  {
    icon: submitRequirementsIcon,
    text: "1. Submit your requirements",
    tag: null
  },
  {
    icon: reviewCandidatesIcon,
    text: "2. Review candidates",
    tag: null
  },
  {
    icon: bookMeetingIcon,
    text: "3. Book a meeting",
    tag: null
  },
  {
    icon: getAugmentedIcon,
    text: "Get started",
    tag: "AUGMENT",
    light: true,
    button: {
      routeName: 'client-project-create'
    }
  },

]

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("h1", _hoisted_3, " Let’s get started! Submit your project and Augment your team " + _toDisplayString(_ctx.api), 1),
    _hoisted_4,
    _createVNode(_unref(NCard), {
      "content-class": "flex-container get-started-steps",
      size: "medium",
      bordered: false
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(NGrid), {
          "x-gap": 24,
          cols: steps.length
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(steps, (step, key) => {
              return _createVNode(_unref(NGi), {
                class: "step-card",
                key: key
              }, {
                default: _withCtx(() => [
                  (step.button)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        class: "ripple-button",
                        to: { name: step.button.routeName }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NCard), {
                            size: "small",
                            bordered: false
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                  _createElementVNode("div", {
                                    class: "step-icon",
                                    innerHTML: step.icon
                                  }, null, 8, _hoisted_7)
                                ]),
                                _createElementVNode("div", _hoisted_8, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["body-text-md step-card-text", { 'text-white': step.light }])
                                  }, _toDisplayString(step.text), 3),
                                  (step.tag)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _hoisted_9,
                                        _createVNode(_unref(NTag), {
                                          class: "augment-tag",
                                          bordered: false,
                                          type: "success",
                                          size: "small"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(step.tag), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : (_openBlock(), _createBlock(_unref(NCard), {
                        key: 1,
                        "content-class": "step-card",
                        size: "small",
                        bordered: false
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("div", {
                                class: "step-icon",
                                innerHTML: step.icon
                              }, null, 8, _hoisted_12)
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["body-text-md step-card-text", { 'text-white': step.light }])
                              }, _toDisplayString(step.text), 3),
                              (step.tag)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _hoisted_14,
                                    _createVNode(_unref(NTag), {
                                      class: "augment-tag",
                                      bordered: false,
                                      type: "success",
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(step.tag), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1024))
                ]),
                _: 2
              }, 1024)
            }), 64))
          ]),
          _: 1
        }, 8, ["cols"])
      ]),
      _: 1
    })
  ]))
}
}

})